module.exports = __webpack_public_path__ + "static/microsoft-powerapps-empower-51f9658630cc7ca374c6f9debc42dcce.png";